var _g, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3161 8.1066V10.7813C24.3161 12.5277 23.2109 13.6329 21.4646 13.6329H17.6846V5.90713C17.6846 4.68028 18.6904 3.68555 19.9172 3.68555C21.122 3.6966 22.2272 4.18292 23.023 4.9787C23.8188 5.78555 24.3161 6.89081 24.3161 8.1066Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21094 9.21186V24.6855C2.21094 25.6029 3.24986 26.1224 3.97933 25.5698L5.86936 24.155C6.31146 23.8234 6.93042 23.8677 7.32831 24.2655L9.16302 26.1113C9.59407 26.5424 10.3015 26.5424 10.7325 26.1113L12.5894 24.2545C12.9762 23.8677 13.5952 23.8234 14.0262 24.155L15.9162 25.5698C16.6457 26.1113 17.6846 25.5919 17.6846 24.6855V5.89607C17.6846 4.68028 18.6794 3.68555 19.8951 3.68555H7.73725H6.63199C3.3162 3.68555 2.21094 5.66397 2.21094 8.1066V9.21186Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63184 11.4219H13.2634",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46094 15.8438H12.4346",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7898 6.63199V9.30673C25.7898 11.053 24.6845 12.1583 22.9382 12.1583H19.1582V4.43252C19.1582 3.20567 20.164 2.21094 21.3909 2.21094C22.5956 2.22199 23.7009 2.70831 24.4966 3.5041C25.2924 4.31094 25.7898 5.4162 25.7898 6.63199Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68457 7.73725V23.2109C3.68457 24.1283 4.72349 24.6478 5.45296 24.0951L7.34299 22.6804C7.78509 22.3488 8.40405 22.393 8.80194 22.7909L10.6367 24.6367C11.0677 25.0678 11.7751 25.0678 12.2062 24.6367L14.063 22.7799C14.4499 22.393 15.0688 22.3488 15.4998 22.6804L17.3899 24.0951C18.1193 24.6367 19.1583 24.1173 19.1583 23.2109V4.42146C19.1583 3.20567 20.153 2.21094 21.3688 2.21094H9.21089H8.10562C4.78983 2.21094 3.68457 4.18936 3.68457 6.63199V7.73725Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10547 9.94727H14.737",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93457 14.3691H13.9083",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.a120dfcde206bebeb1b70e60c389b401.svg";
export { ForwardRef as ReactComponent };